




































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import moment from "../../../../node_modules/moment";
import AbpBase from "../../../lib/abpbase";
import Thdata from "../../../store/entities/thdata";
import Echarts from "../threaltimedata/Echarts.vue";
import EchartsHumi from "../threaltimedata/Echarts.vue";
import PageRequest from "@/store/entities/page-request";
class PageThRealTimeDataRequest extends PageRequest {
  AddTime: Date=new Date();
  mac: string;
  locationName:string;
  StartTime:Date = new Date();
  EndTime:Date = new Date();
  AcqInt:Number;
}
@Component({
  components: { Echarts,EchartsHumi },
})

export default class AnalyseThrealtimedata extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Date}) AddTime: Date;
   @Prop({ type: String}) mac: string;
   @Prop({type:String}) locationName:string;
  @Prop({ type: Date}) StartTime: Date;
  @Prop({ type: Date}) EndTime: Date;
  @Prop({ type: Number}) AcqInt: Number;
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  componentKey: number = 10;
  componentKeyhumi:number=10;
  datalist = [];
  legenddata: string = "";
  xAxisdata: string = "";
  seriesdata: string = "";
  humiseriesdata: string = "";
  yAxisdata:string="";
  serieslist = [];
  humiserieslist = [];
  humistrtitle:string="";
  yAxislist=[];
  thdata: Thdata = new Thdata();
  list=[];
  strtitle:string="";

  async getPage() {
    //filters
    //debugger;
    //let ss=this.value;
    this.pagerequest.AddTime=this.AddTime;
    this.pagerequest.mac=this.mac;
    this.pagerequest.StartTime = this.StartTime;
    this.pagerequest.EndTime = this.EndTime;
    this.list=await this.$store.dispatch({
      type: "thdata/getLostData",
      data: this.pagerequest,
    });
    //this.ThisThPaged();
    this.strtitle='温度走势图';
    this.humistrtitle='湿度走势图';
    let titlelist = ["一号针", "二号针", "三号针"];

    this.serieslist.push(
      {
        name: "一号针",
        type: "line",
        data: [],
      },
      {
        name: "二号针",
        type: "line",
        data: [],
      },
      {
        name: "三号针",
        type: "line",
        data: [],
      }
    );
    let timelist = [];
    // for (let i = 0; i < 24; i++) {
    //   timelist.push(i.toString() + ":00");
    // }

    let datalist_inline1 = [];
    let datalist_off1 = [];
    let datalist_inline2 = [];
    let datalist_off2 = [];
    // for (let entry of this.list) {
    //     timelist.push(this.GetMinutes(entry.addTime));
    //     datalist_temp1.push(entry.temp1);
    //     datalist_humi1.push(entry.humi1);
    //     datalist_temp2.push(entry.temp2);
    //     datalist_humi2.push(entry.humi2);
    //     datalist_temp3.push(entry.temp3);
    //     datalist_humi3.push(entry.humi3);
      
    // }
    for(var i=0;i<this.list.length - 1;i++){
       timelist.push(this.GetMinutes(this.list[i].addTime));
       if(i == this.list.length - 2){
         timelist.push(this.GetMinutes(this.list[i + 1].addTime));
       }
      var addtime1 = this.GetMinutes(this.list[i].addTime);
      var addtime2 = this.GetMinutes(this.list[i + 1].addTime);
      if(addtime1 != addtime2){
        let time1 = new Date(this.list[i].addTime);
        let time2 = new Date(this.list[i+1].addTime);
        time1.setMinutes(time1.getMinutes() + 32);
        if(time1 > time2){
         datalist_inline1.push(addtime1);
         datalist_inline2.push(addtime2);
        }
        else{
        datalist_off1.push(addtime1);
        datalist_off2.push(addtime2);
        }
      }
      
    }
    // console.log(datalist_off1);
    // console.log(datalist_off2);
    // console.log(datalist_inline1);
    // console.log(datalist_inline2);
    this.serieslist[0].data = datalist_inline1;
    this.serieslist[1].data = datalist_inline2;
    this.humiserieslist[0].data = datalist_off1;
    this.humiserieslist[1].data = datalist_off2;

    this.legenddata = JSON.stringify(titlelist);
    this.seriesdata = JSON.stringify(this.serieslist);
    this.humiseriesdata = JSON.stringify(this.humiserieslist);
    this.xAxisdata = JSON.stringify(timelist);
    this.yAxisdata = this.mac;
    this.showEcharts();
  }
 GetMinutes(time) {
    let date = new Date(time);
    let Str = this.GetBqMinutes(date.getHours()) + ":" + this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetBqMinutes(str){
    if(str.toString().length==1){
      return '0'+str;
    }
    return str;
  }
  visibleChange(value: boolean) {

    // this.ThisThPaged();

    if (!value) {
      this.$emit("input", value);
    } else {
      // this.thdata = Util.extend(
      //   true,
      //   {},
      //   this.$store.state.thdata.analyseThdata
      // );
      //console.log(this.$store.state.thdata.analyseThdata);
      this.getPage();
    }
    
  }

  cancel() {
    //this.getPage();
    this.$emit("input", false);
  }

  showEcharts() {
    this.componentKey += 1;
    this.componentKeyhumi+=1;
  }

  // async ThisThPaged(){
  //  this.list=await this.$store.dispatch({
  //     type:"thdata/getThisThPaged",
  //   });
  //   //return this.list;
    
  // }

 
}
